import { ProcessedCourse } from "@/common/course/types";
import { CourseBadge } from "@/components/CourseContent/CourseBadges";

export type BadgesByProductUuid = {
  position: "below-subheader" | "above-subheader";
  badges: CourseBadge[];
};
const leadershipPillBadges = {
  position: "below-subheader",
  badges: [
    {
      type: "pre-start",
      color: "pink",
      borderless: true,
    },
    {
      type: "start-today",
      color: "pink",
      borderless: true,
    },
    {
      type: "last-chance",
      color: "pink",
      borderless: true,
    },
    {
      type: "custom",
      text: "Top Leadership Program",
      icon: "ai",
      color: "fern",
      borderless: true,
    },
  ],
};

const lseMbaEssentialsBadges = {
  position: "below-subheader",
  badges: [
    {
      type: "pre-start",
      color: "pink",
      borderless: true,
    },
    {
      type: "start-today",
      color: "pink",
      borderless: true,
    },
    {
      type: "last-chance",
      color: "pink",
      borderless: true,
    },
    {
      type: "custom",
      text: "Now updated for the AI era",
      icon: "ai",
      color: "fern",
      borderless: true,
    },
  ],
};

const dataPillBadges = {
  position: "below-subheader",
  badges: [
    {
      type: "pre-start",
      color: "pink",
      borderless: true,
    },
    {
      type: "start-today",
      color: "pink",
      borderless: true,
    },
    {
      type: "last-chance",
      color: "pink",
      borderless: true,
    },
    {
      type: "custom",
      text: "Top Data Program",
      icon: "ai",
      color: "fern",
      borderless: true,
    },
  ],
};

const aiPillBadges = {
  position: "below-subheader",
  badges: [
    {
      type: "pre-start",
      color: "pink",
      borderless: true,
    },
    {
      type: "start-today",
      color: "pink",
      borderless: true,
    },
    {
      type: "last-chance",
      color: "pink",
      borderless: true,
    },
    {
      type: "custom",
      text: "Top AI Program",
      icon: "ai",
      color: "fern",
      borderless: true,
    },
  ],
};

const financePillBadges = {
  position: "below-subheader",
  badges: [
    {
      type: "pre-start",
      color: "pink",
      borderless: true,
    },
    {
      type: "start-today",
      color: "pink",
      borderless: true,
    },
    {
      type: "last-chance",
      color: "pink",
      borderless: true,
    },
    {
      type: "custom",
      text: "Top Finance Program",
      icon: "ai",
      color: "fern",
      borderless: true,
    },
  ],
};

// UUID to badge mapping
const UUID_TO_BADGE_MAPPING = {
  // Leadership pill
  "d4faa293-9be0-406e-9861-3f8ffe3668b0": leadershipPillBadges,
  "a626c6e3-1041-4937-94fe-d144c8355a2d": leadershipPillBadges,
  "b3f587fc-0cee-4dbd-8bac-b2687731a40d": lseMbaEssentialsBadges,
  "83d8b90b-40d5-443c-99fd-6ea813c19538": leadershipPillBadges,

  // Data pill
  "3cb02711-99a9-44ac-9acd-ef20cb346e43": dataPillBadges,
  "aae08bb5-6d16-47ba-bd22-d86f0aad7d44": dataPillBadges,
  "a03303b4-9c70-42fb-a537-1d71ed63e7a6": dataPillBadges,

  // Finance pill
  "fae65ccb-b081-41a7-a68e-954369c38ff1": financePillBadges,
  "b30b2520-7f97-4792-a116-b82e9ffdbfab": financePillBadges,

  // AI pill
  "a69081ed-907a-4755-8779-b1fa7b1e10b2": aiPillBadges,
  "32ab61e5-44b4-4316-ad59-9f04fc876e0a": aiPillBadges,
  "2e0e0b5c-0707-4bf1-bac1-45ca1cda728d": aiPillBadges,
  "ce3a934a-08ff-47da-823e-15f99cae32ef": aiPillBadges,
  "e80aca57-9eeb-4d74-95d7-c5496b02388b": aiPillBadges,
  "67e79d7e-af58-49f3-9dc4-c94b6efdfcf1": aiPillBadges,
} as Record<string, BadgesByProductUuid>;

const defaultBadges = [
  {
    type: "pre-start",
    color: "pink",
    borderless: true,
  },
  {
    type: "start-today",
    color: "pink",
    borderless: true,
  },
  {
    type: "last-chance",
    color: "pink",
    borderless: true,
  },
] as CourseBadge[];

export function getBadgesByProductUuid(
  course: ProcessedCourse,
): BadgesByProductUuid | null {
  if (!course?.productUuid) {
    return null;
  }

  return (
    UUID_TO_BADGE_MAPPING[
      course.productUuid as keyof typeof UUID_TO_BADGE_MAPPING
    ] ?? { position: "below-subheader", badges: defaultBadges }
  );
}
